// The one list foot (consistency pass, R5 B6 and R7 N7, Kristi Nov 1): "Showing 20 of 312" only
// while not everything is shown, then links: Show 20 more · Show all 312 · Show fewer.

export function fmtNum(n: number): string {
  return n.toLocaleString('en-US');
}

export function ListFoot({
  shown,
  total,
  page = 20,
  noun,
  onMore,
  onAll,
  onFewer,
  extra,
}: {
  shown: number;
  total: number;
  page?: number;
  /** ["book", "books"]: adds the noun to "Showing 20 of 312 books". */
  noun?: [string, string];
  onMore: () => void;
  onAll: () => void;
  onFewer: () => void;
  /** Anything else on the line (the Queue's "· 14 on Up Next"). */
  extra?: string;
}) {
  const all = shown >= total;
  if (total <= page) return extra ? <div class="list-foot"><span class="list-foot-line">{extra}</span></div> : null;
  const left = total - shown;
  return (
    <div class="list-foot">
      {!all ? (
        <span class="list-foot-line">
          Showing {fmtNum(shown)} of {fmtNum(total)}
          {noun ? ` ${total === 1 ? noun[0] : noun[1]}` : ''}
          {extra ? ` · ${extra}` : ''}
        </span>
      ) : extra ? (
        <span class="list-foot-line">{extra}</span>
      ) : null}
      {!all ? (
        <button type="button" class="btn-link" onClick={onMore}>
          Show {fmtNum(Math.min(page, left))} more
        </button>
      ) : null}
      {!all ? (
        <button type="button" class="btn-link" onClick={onAll}>
          Show all {fmtNum(total)}
        </button>
      ) : null}
      {shown > page ? (
        <button type="button" class="btn-link" onClick={onFewer}>
          Show fewer
        </button>
      ) : null}
    </div>
  );
}
